__turbopack_context__.v({
  "heading": "error-module__4qRlQa__heading",
  "message": "error-module__4qRlQa__message",
  "wrapper": "error-module__4qRlQa__wrapper",
});
